/**
 * "You've arrived at OZORA" — the page's half (plan.md step 60 task 4). When
 * the person has switched it on, the phone app is handed the PLACES of the
 * raves this account attends (`arrivalRegions`, `@myrave/shared`) — the
 * rave's own point, never the person's — and the shell's geofence does the
 * rest. Sent once per load and whenever the list changes; switched off, the
 * shell is told to stop.
 */
import { arrivalRegions } from '@myrave/shared';
import { endpoints, shownTr } from './api';
import { inNativeApp, keptArrivalAlerts, setArrivalRegions } from './nativeBridge';
import { readJson, writeJson } from './storage';
import { festivalUrl } from './tenant';

const SENT = 'arrival-sent';
const tr = shownTr;

/** The notice in the reader's language (step 73) — the shell writes what it is given. */
const arrivalWords = (name: string) => ({
  title: tr("You're at {rave} 🎉", { rave: name }),
  body: tr('Welcome! Your lineup and the map work with no signal — tap to open the rave.'),
});

/** Bring the shell in line with the setting and the raves. `force` sends even an unchanged list (the switch). */
export async function syncArrivals(force = false): Promise<{ on: boolean; reason?: 'permission' | 'error' } | null> {
  if (!inNativeApp()) return null;
  if (!keptArrivalAlerts()) {
    if (!force && readJson<string>(null, SENT, '[]') === '[]') return null;
    writeJson(null, SENT, '[]');
    return setArrivalRegions([]);
  }
  const mine = await endpoints.myFestivals().catch(() => null);
  if (!mine) return null;
  const regions = arrivalRegions(mine.festivals, new Date(), festivalUrl, arrivalWords);
  const json = JSON.stringify(regions);
  if (!force && readJson<string>(null, SENT, '[]') === json) return null;
  const answer = await setArrivalRegions(regions);
  if (answer?.on || regions.length === 0) writeJson(null, SENT, json);
  return answer;
}
